module.exports = __webpack_public_path__ + "media/spot.aa8ca565.mp4";